import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Chart } from "chart.js";
@Component({
  selector: 'sb-charts-pie',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnInit, OnChanges {
  @Input() dataChart: { labels: string[]; data: number[]; backgroundColors: string[]; title: string, typeChart:string};
  @Input() chartInputId:any;
  chart: any;
  chartId: string="1";
  constructor() { }
  ngOnInit(): void {
    this.chartId=this.chartInputId;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataChart.currentValue) {
      this.createChart();
    }
  }
  createChart(){
    this.chart = new Chart(this.chartId, {
      type:this.dataChart?.typeChart, //typeChart: doughnut, pie
      data: {// values on X-Axis
        labels: this.dataChart?.labels,
	      datasets: [{                     
                      data: this.dataChart?.data,
                      backgroundColor: this.dataChart?.backgroundColors,
                      hoverOffset: 4
                  }],
      },
      options: {
        aspectRatio:2.5,
        legend: {
              position: "right"
            },
        title: {
          display: this.dataChart?.title==undefined ? false : true,
          text:  this.dataChart?.title,
          position:"bottom"
        },
        scales: {
            yAxes: [{
              ticks: {
                reverse: false
              }
            }]
        }
        ,responsive: true
        ,maintainAspectRatio: true
        ,plugins: {
          labels: {
            render: 'percentage',
            precision: 2
          }
        },
        
      }

    });
  }

}
